module.exports = __webpack_public_path__ + "img/logo.0a146ff3.png";